import { useAppSelector } from "@app/hooks";
import { useInjectReducer } from "@app/store";
import Button from "@components/Button";
import PageContent from "@components/PageContent";
import PageHeader from "@components/PageHeader";
import {
  useLoadAccessModuleMutation,
  useSaveAccessMutation,
} from "@features/admin/modules/moduleApiSlice";
import moduleSlice, { updateAccess } from "@features/admin/modules/moduleSlice";
import { APP_NAME } from "@utils/constants";
import { useEffect } from "react";
import { Helmet } from "react-helmet";
import {
  RiAddLine,
  RiCheckboxBlankCircleLine,
  RiCheckboxCircleFill,
} from "react-icons/ri";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

const ModuleAccessManage = () => {
  useInjectReducer("module", moduleSlice);

  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    access: { Roles, Module, Access },
  } = useAppSelector("module");
  const [loadAccess, { isLoading, isError }] = useLoadAccessModuleMutation();
  const [
    saveAccess,
    { isLoading: saveLoading, isError: saveError, error: saveErrorObj },
  ] = useSaveAccessMutation();

  useEffect(() => {
    if (id) {
      loadAccess(id);
    }
  }, []);

  const handleSave = () => {
    saveAccess({
      id,
      data: { Access },
    })
      .unwrap()
      .then((res) => {
        if (res?.success) {
          navigate("/admin/module-manage");
        }
      });
  };

  return (
    <>
      <Helmet>
        <title>{`${id ? "Edit Access" : "Add Access"} | ${APP_NAME}`}</title>
      </Helmet>
      <div className='flex justify-between items-center mb-3'>
        <PageHeader
          title={id ? "Edit Access" : "Add Access"}
          isBack
          handleGoBack={() => navigate("/admin/module-manage")}
        />
        {id && (
          <Button
            leftSection={<RiAddLine />}
            onClick={() => navigate(`/admin/module-manage/edit/${id}`)}
          >
            Add Access
          </Button>
        )}
      </div>
      <PageContent loading={isLoading}>
        <div className='border border-gray-300 text-sm p-4'>
          {Roles.map((role) => {
            const accessFiltered = Access.filter(
              (each) => each.role_id === role._id
            );
            let accesses = [];
            if (accessFiltered.length > 0) {
              accesses = [...accessFiltered[0].access_type].flat();
            }
            return (
              <div
                className='flex items-center border-b border-gray-300'
                key={role._id}
              >
                <h3 className='text-sm font-semibold w-48 m-0'>
                  {role.role_title}
                </h3>
                <div className='flex-1 flex gap-6'>
                  {Module.path.map((eachPath) => (
                    <div
                      className={`flex items-center gap-1 py-4 cursor-pointer hover:text-green-600 ${
                        accesses.includes(eachPath._id)
                          ? "text-green-600"
                          : "text-gray-600"
                      }`}
                      key={`${eachPath._id}-${role._id}`}
                      value={eachPath._id}
                      onClick={() =>
                        dispatch(
                          updateAccess({
                            module_id: accesses,
                            roleId: role._id,
                            ModuleId: Module._id,
                            singlePath: eachPath._id,
                          })
                        )
                      }
                    >
                      {accesses.includes(eachPath._id) ? (
                        <RiCheckboxCircleFill size={18} />
                      ) : (
                        <RiCheckboxBlankCircleLine size={18} />
                      )}
                      {eachPath.access_type}{" "}
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
          <Button className='mt-4' loading={saveLoading} onClick={handleSave}>
            Save Changes
          </Button>
        </div>
      </PageContent>
    </>
  );
};

export default ModuleAccessManage;
